import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {}

export const setAction_Model = ({ eventEmitter }: Props) => {
    apiProvider.setActiveAction({action: 'model'})
    eventEmitter.emit(Event.setActionBar_Model);
};
